import React, { useState } from "react";
import { useWindowDimensions, Button } from "react-native";
import MCALayout from "../../components/MCALayout";
import { SceneMap, TabView, TabBar } from "react-native-tab-view";
import HowItWorks from "./HowItWorks";
import Benefits from "./Benefits";
import HowToClaim from "./HowToClaim";
import { colorPrimary } from "../../theme/colors";
// import type { NavigationProp, RouteProp } from "@react-navigation/native";

type ProductData = {
  [key: string]: any;
  // Define your product data type here
};

// type RouteParams = {
//   [key: string]: any;
// };


type ProductInfoProps = {
    [key: string]: any;
//   navigation: NavigationProp<any, any>;
//   route: RouteProp<RouteParams, "productData">;
};

const ProductInfo: React.FC<ProductInfoProps> = ({ navigation, route}) => {
  const productData: ProductData = route.params?.productData;

  const howItWorks = () => <HowItWorks data={productData} />;
  const benefits = () => <Benefits data={productData} />;
  const howToClaim = () => <HowToClaim data={productData} />;

  const renderScene = SceneMap({
    howItWorks: howItWorks,
    benefits: benefits,
    howToClaim: howToClaim,
  });

  const layout = useWindowDimensions();

  const [index, setIndex] = useState(0);
  const [routes] = useState([
    { key: "howItWorks", title: "How It Works" },
    { key: "benefits", title: "Benefits" },
    { key: "howToClaim", title: "How To Claim" },
  ]);

  const renderTabBar = (props: any) => (
    <TabBar
      {...props}
      indicatorStyle={{ backgroundColor: "#F2F4F7" }}
      activeColor="#3BAA90"
      inactiveColor="#364657"
      labelStyle={{
        textTransform: "none",
        fontFamily: "Raleway_500Medium",
        textAlign: "center",
        fontSize: 12,
        fontWeight: "600",
      }}
      style={{ backgroundColor: "#F2F4F7", elevation: 0 }}
    />
  );

  function nextScreen() {
    console.log(productData);
    console.log(1);
    navigation.navigate("ProductForm", { data: productData });
  }

  return (
    <MCALayout>
      <TabView
        style={{ flex: 1 }}
        swipeEnabled={false}
        navigationState={{ index, routes }}
        renderScene={renderScene}
        onIndexChange={setIndex}
        initialLayout={{ width: layout.width }}
        renderTabBar={renderTabBar}
      />
      <Button title="Continue" color={colorPrimary} onPress={nextScreen} />
    </MCALayout>
  );
};

export default ProductInfo;
